import React from 'react';
import moment from 'moment';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import Scrollbar from 'src/ui/library/Scrollbar';
import { formatDate } from 'src/helpers/date';
import WithHeader from '../../wrappers/WithHeader';
import ToolTip from 'src/ui/library/ToolTip';

const ReadOnlyControl = props => {
  const { label, value, listOptions, origControlTypeName, helpText } = props;

  let finalValue = value && value !== '' && origControlTypeName === 'Date' ? formatDate(value) : value;

  // fix for dates not rendering in Edge
  if (origControlTypeName === 'Date' && !moment(value).isValid() && typeof value !== 'object') {
    var dateStr = value.replace(/-/g, ' ');
    finalValue = formatDate(dateStr);
  }

  finalValue = origControlTypeName === 'CheckBox' ? finalValue.charAt(0).toUpperCase() + finalValue.slice(1) : finalValue;
  if (listOptions) {
    listOptions.forEach(item => {
      if (item.lookUpBindValue === value) {
        const displayLabel = (item.displayText || '').split('|').shift();
        finalValue = displayLabel;
      }
    });
  }

  if (finalValue == null || finalValue === '') {
    finalValue = <span style={{ fontSize: '1.2rem' }}>&mdash;</span>;
  }

  return (
    <div className="parser-readonly-control">
      <ToolTip title={label} hideButton={true}>
        <label className="readonly-label">
          {label}
          {helpText && <span>&nbsp;&nbsp;</span>}
          {helpText && <InfoTooltip toolTipText={helpText} />}
        </label>
      </ToolTip>
      <Scrollbar autoHeight={false} autoHide={false}>
        <section>
          <span title={finalValue} className="readonly-content" maxLength={12}>
            {finalValue}
          </span>
        </section>
      </Scrollbar>
    </div>
  );
};

export default WithHeader(ReadOnlyControl);
